import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Injectable } from '@angular/core';
import { SessionService } from '../services/ssession.service';

@Injectable({
  providedIn: 'root'
})
export class IsCompletedUserDataGuard implements CanActivate {
  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    return SessionService.IsCompletedUserData() ? true : this.router.parseUrl('/moje-dane?completed=false');
  }
}
